module.exports = __webpack_public_path__ + "img/box3.a236415c.jpg";